import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {Form, Input} from 'antd';
import {validation} from '../../../../../utils/validation';

const {Item} = Form;

const formFieldProps = {
  size: 'large'
}

const ShortVendorFormItems = () => {
  const [t] = useTranslation(['main', 'vendors']);

  const validationRules = useMemo(() => ({
    bic: validation.bic(t, false),
    iban: validation.iban(t, false),
    required: validation.required(t),
    vat: validation.vat(t),
  }), [t]);

  const requiredItemProps = useMemo(() => ({rules: validationRules.required, required: true}), [validationRules.required]);

  const trans = (key) => t(`vendors:${key}`);

  const formT = (key) => trans(`modal.addVendor.${key}`);

  const placeholder = (key) => formT(`placeholder.${key}`);

  return (
    <>
      <Item
        {...requiredItemProps}
        label={t('name')}
        name='name'
      >
        <Input
          {...formFieldProps}
          placeholder={placeholder('name')}
        />
      </Item>
      <Item
        label={t('vatNumber')}
        name='vat'
        rules={validationRules.vat}
        required
      >
        <Input
          {...formFieldProps}
          maxLength={15}
          placeholder={placeholder('vat')}
        />
      </Item>
      <Item
        label={t('iban')}
        name='iban'
        rules={validationRules.iban}
      >
        <Input
          {...formFieldProps}
          placeholder={placeholder('iban')}
        />
      </Item>
      <Item
        label={t('bic/swift')}
        name='bic'
        rules={validationRules.bic}
      >
        <Input
          {...formFieldProps}
          placeholder={placeholder('bic')}
        />
      </Item>
    </>
  );
}

export default ShortVendorFormItems;
